import type {GetSyncPromiseOptions, SyncPromise} from '@gaia/utils/abstractGetSyncPromise';

import useGetSyncPromise from './useGetSyncPromise';

export default function useSyncPromise<T>(
    promise: Promise<T> | T,
    defaultValue?: T,
    options?: GetSyncPromiseOptions
): SyncPromise<T> {
    const getSyncPromise = useGetSyncPromise(options);
    return getSyncPromise(promise, defaultValue);
}
